// extracted by mini-css-extract-plugin
export default {"publish-version-menu":"styles_publish-version-menu__ZvowR","publish-version-item":"styles_publish-version-item__Qgvr3"};